/* eslint-disable max-len */
import React, { Fragment, useRef, useState} from 'react';
import 'tw-elements';
import TableBody from './TableBody';
import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick';
import {  useSelector } from 'react-redux';
const Table = ({pageNumber, handleOnClickSort, sortValue, setConfirmationState,email,setLoading, isRole}) => {
    const [selectedIndex, setSelectedIndex] = useState(null); 
    const selectedRef = useRef();
    const AcademicYearList = useSelector(state => state.AcademicYearSlice);
    const { List } = AcademicYearList
    const urlParams = new URLSearchParams(window.location.search);
    const branchUrl = urlParams.get('sort');

    /* `useOnClickOutside` is a custom hook that takes two arguments: a ref and a callback function. It
    is used to detect clicks outside of a specific element (in this case, the `selectedRef` element)
    and trigger the callback function (`setSelectedIndex(null)`) when a click is detected outside of
    that element. In this specific code, it is used to close a dropdown menu when a user clicks
    outside of it. */
    useOnClickOutside(selectedRef, () => {
        setSelectedIndex(null)
    });

    /**
     * The function handles sorting based on a given key and current sort value.
     */
    const handleSort = (key) => {
        setLoading(true);
        if(sortValue === '') handleOnClickSort('sort', `${key}+asc`)
        else {
            if(sortValue.includes(key)) handleOnClickSort('sort', `${key}+${sortValue.includes('+desc') ? 'asc' : 'desc'}`)
            else handleOnClickSort('sort', `${key}+asc`)
        }
    }
    return (
        <div class="-mx-1">
            <div className={`flex mb-1 overflow-auto pr-2  ${List?.data?.length < 10 ? 'pb-[62px]' : 'pb-[6px]'} scroll-bar px-1`} id = "search-result" >
                <table aria-label="Outside Table" className="w-full" id='admin-table'>
                    <thead>
                        <tr>
                            <th class="w-[20%]">
                                <span >Academic Year Name
                                </span>
                            </th>
                            <th class="w-[10%]">
                                <span class="flex items-center justify-start ">Start Date
                                </span>
                            </th>
                            <th class="w-[10%]">
                                <span >End Date
                                </span>
                            </th>
                            <th class="w-[10%]"  onClick={() => {handleSort('status')}}>
                                <span id='status' >Status
                                    <button type="button" class="pl-1.5 sortedIcon">
                                        <img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "status" ? branchUrl?.split("+")[1] === "asc" ? "/images/sortAsc.svg" : "/images/sortDesc.svg" : "/images/Vector.svg"} alt="icon"/>
                                    </button>
                                </span>
                            </th>
                            {!isRole && <th class="w-[12%]">
                                <span class="flex items-center justify-center">Action
                                </span>
                            </th>}
                        </tr>
                        <tr aria-colspan="7" class="h-1">
                        </tr>
                    </thead>
                    <tbody>
                        {List.data.map((item , index = 0) => (
                            <Fragment key={item._id}>
                                <TableBody
                                    tableData={item}
                                    setConfirmationState={setConfirmationState}
                                    indexNum={index}
                                    pageNumber={pageNumber}
                                    selectedIndex={selectedIndex}
                                    setSelectedIndex={setSelectedIndex}
                                    selectedRef={selectedRef}
                                    lastIndex={List.data?.length}
                                    email={email}
                                    isRole={isRole}
                                />
                            </Fragment>
                        ))}
                        
                    </tbody>
                    {List?.data?.length === 0 && (
                        <tbody>
                            <tr>
                                <td style={{ 'line-height': '100px' }} colspan="5" className="no-records-message" id='no-matching-result'>
                                    {`No Academic Years added yet.`}
                                </td>
                            </tr>
                        </tbody>
                    )}
                </table>
            </div>
        </div>
    );
}

export default Table;
